<script>
//  弹窗组件，所欲设置的弹窗组件
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      judge   : false,
      modalName : '',
      modaldata : {
        data : {},
        Zindex : 0,
      },
    };
  },
  computed: {
    ...mapGetters([
      'TopNav_Size',
      'TOOL',
      'StyleMsg',
      'Window_Size',
      'UserMsg',
    ])
  },
  props: ['boxData', 'dataMsg'],
  watch : {
    'boxData' : function(val, oldval){ // 判断打开关闭
      let num = Array.indexOf(this.boxData, this.modalName);
      this.judge = num < 0 ? false : true; // 判断是否打开


      if (this.judge ) { // 打开的操作
        this.modaldata.data     = this.dataMsg[this.modalName];
        this.modaldata.Zindex   = (this.boxData.length + 1)*5;
      }

    },
  },
  mounted () {

  },
  methods: {
    stopDocument(e){      // 防止事件冒泡
      e.stopPropagation();
    },
    closeModal(){
      this.$bus.emit('Modal_close_vue', {name: this.modalName});
    },
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/modal.vue